<template>
  <div>
    <h1 class="m-label">家庭</h1>
    <div class="m-box__inner2">
      <template v-if="appointment.family">
        <ul class="m-List">
          <li class="m-Item">
            <div class="m-Item__block">
              <div class="m-Item__content">
                <i class="fa fa-user-circle"></i>
                <div>{{appointment.family.f_name}} {{appointment.family.l_name}} ({{appointment.family.f_name_kana}} {{appointment.family.l_name_kana}})</div>
                <div>{{appointment.family.note1}}</div>
                <div>{{appointment.family.note2}}</div>
              </div>
              <div class="m-Item__content2">
                <btn class="jump" @click.native="linkFamily(appointment.family)"><i class="fa fa-address-card"></i></btn>
                <btn class="delete" @click.native="deleteAppointmentFamily(appointment.family)"><i class="fa fa-trash"></i></btn>
              </div>
            </div>
          </li>
        </ul>
      </template>
    </div>
    <appointment-family-modal :appointment="appointment"></appointment-family-modal>
  </div>
</template>

<script>
export default {
  props: {
    appointment: Object
  },
  name: 'AppointmentFamily',
  data () {
    return {

    }
  },
  methods: {
    linkFamily (appointmentFamily) {
      this.$router.push({ name: 'family', params: { id: appointmentFamily.id } })
    },
    deleteAppointmentFamily (list) {
      this.$store.dispatch('deleteAppointmentFamily', list)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss'>
.m-List {
  list-style-type: none;
  margin:0;
  padding:0;
}
.m-Item {
  border: 1px solid #eee;
  position: relative;
  .fa-user-circle {
    font-size: 50px;
  }
  &__block {
    word-wrap: break-word;
    display: flex;
    &--boy {
      border-left: solid 3px #3F51B5;
      .m-Item__content {
        .fa-user-circle {
          color: #3F51B5;
        }
      }
      .m-Item__content2 {
        .jump {
          background: #37474F;
        }
        .delete {
          background: #546E7A;
        }
      }
    }
    &--girl {
      border-left: solid 3px #E91E63;
      .m-Item__content {
        .fa-user-circle {
          color: #E91E63;
        }
      }
      .m-Item__content2 {
        .jump {
          background: #37474F;
        }
        .delete {
          background: #546E7A;
        }
      }
    }
    .m-Item__content {
      flex-grow: 1;
      width: 85%;
      padding: 1em;
    }
    .m-Item__content2 {
      flex-grow: 1;
      width: 30px;
      display: flex;
      flex-flow: column nowrap;
      .jump {
        margin: 0;
        flex-grow: 3;
        padding: 0;
      }
      .delete {
        margin: 0;
        flex-grow: 1;
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentFamily.vue?62957889